import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

/*
    Prefixa o título da aba do navegador com a quantidade de mensagens
    de chat não lidas — estilo WhatsApp Web. Restaura o título original
    quando não há mensagens pendentes ou quando o componente desmonta.
*/
export default function useChatTabTitle() {
	const naoLidas = useSelector((state) => state.menu?.chat || 0);
	const tituloOriginalRef = useRef(null);

	useEffect(() => {
		if (tituloOriginalRef.current === null) {
			tituloOriginalRef.current = document.title.replace(/^\(\d+\)\s+/, "");
		}
		const base = tituloOriginalRef.current || "treino.io";

		if (naoLidas > 0) {
			const contador = naoLidas > 99 ? "99+" : String(naoLidas);
			document.title = `(${contador}) ${base}`;
		} else {
			document.title = base;
		}
	}, [naoLidas]);

	useEffect(() => {
		return () => {
			if (tituloOriginalRef.current) {
				document.title = tituloOriginalRef.current;
			}
		};
	}, []);
}
